import { atom } from 'recoil';
import { Node } from 'reactflow';

export const workflowNodesState = atom<Node[]>({
  key: 'workflowNodesState',
  default: []
});
